import $ from 'jquery'
import {orgText} from '../cads/cache/get'

const getInventoryAdjustments = (orgId, callback) => {
  let randomNum = Math.floor(Math.random()*99999999).toString()
  let url = 'https://' + process.env.REACT_APP_S3_BUCKET_NAME + '.s3.amazonaws.com/caches/inventory_adjustments' + orgText(orgId) + '.json?t=' + randomNum

  $.get(url, function (result) {
    callback(typeof result === 'string' ? JSON.parse(result) : result)
  }).fail(function () {
    callback({})
  })
}

export {getInventoryAdjustments}
